export default __webpack_public_path__ + "static/media/icon-react.284ea22a.jpg";